// extracted by mini-css-extract-plugin
export default {"panelHeader":"ProductSearch_panelHeader__Wwqx8"};